import { render, staticRenderFns } from "./accidentInfo.vue?vue&type=template&id=65a68160&scoped=true&"
import script from "./accidentInfo.vue?vue&type=script&lang=js&"
export * from "./accidentInfo.vue?vue&type=script&lang=js&"
import style0 from "./accidentInfo.vue?vue&type=style&index=0&id=65a68160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a68160",
  null
  
)

export default component.exports